<template>
    <div>
        <Navbar />
        <div class="owner-body">
            <div class="sidebar">
                <Sidebar />
            </div>
            <div class="page">
                <card-component>
                    <div class="heading">
                        <h3>Pricing</h3>
                    </div>
                    <div v-if="edit" class="pricing-form">
                        <div class="kerosene">
                            <label for="Kerosene">Kerosene</label>
                            <b-input class="input-part" v-model="kerosene"></b-input>
                        </div>
                        <div class="petrol">
                            <label for="Petrol">Petrol</label>
                            <b-input class="input-part" v-model="petrol"></b-input>
                        </div>
                        <div class="diesel">
                            <label for="Diesel">Diesel</label>
                            <b-input class="input-part" v-model="diesel"></b-input>
                        </div>
                        <div class="buttons">
                            <div>
                                <b-button class="save">Save changes</b-button>
                                <b-button @click="cancelEdit" class="cancel">Cancel</b-button>
                            </div>
                            <b-button class="request">Request to add more fluids</b-button>
                        </div>
                    </div>
                    <div v-else class="pricing-summary">
                        <div>
                            <div class="pricing-display">
                                <h4>Kerosene</h4>
                                <p>- #246</p>
                            </div>
                            <div class="pricing-display">
                                <h4>Kerosene</h4>
                                <p>- #246</p>
                            </div>
                            <div class="pricing-display">
                                <h4>Kerosene</h4>
                                <p>- #246</p>
                            </div>
                        </div>
                        <b-button @click="editPricing">Edit</b-button>
                    </div>
                </card-component>
            </div>
        </div>
    </div>
</template>

<script>
import Navbar from '@/components/NavBar.vue';
import Sidebar from '@/components/OwnerSidebar.vue';
import CardComponent from '@/components/CardComponent.vue';

export default {
  name: 'Pricing',
  components: {
    Navbar,
    Sidebar,
    CardComponent
  },
  data() {
    return {
      edit: false
    };
  },
  methods: {
    editPricing() {
      this.edit = true;
    },
    cancelEdit() {
      this.edit = false;
    }
  }
};
</script>

<style scoped>
.pricing-summary {
    display: flex;
    justify-content: space-between;
}
.heading h3 {
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  color: #736F6F;
  margin-bottom: 27px;
  text-transform: capitalize;
}
.input-part {
    max-width: 600px;
}
.pricing-display {
    margin-top: 35px;
}
.pricing-display h4 {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 18px;
    color: #000000;
}
.pricing-display p {
    margin-top: 20px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #736F6F;
}
.pricing-summary button {
    font-size: 16px;
    line-height: 18px;
    text-decoration-line: underline;
    color: #3887F6;
    background: none;
    border: none;
}
.kerosene, .petrol, .diesel {
    margin-top: 40px;
}
.buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 73px;
}
.save {
    background: #3887F6;
    box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.15);
    font-size: 16px;
    line-height: 18px;
    letter-spacing: -0.4px;
    color: #FFFFFF;
}
.cancel {
    font-size: 16px;
    line-height: 18px;
    letter-spacing: -0.4px;
    color: #3887F6;
    border: none;
    background: none;
}
.request {
    font-size: 16px;
    line-height: 18px;
    text-decoration-line: underline;
    color: #3887F6;
    border: none;
    background: none;
}
</style>
